module.exports = __webpack_public_path__ + "static/media/read-more-arrow.aac53c99.svg";